module.exports = __webpack_public_path__ + "media/images/soar/operation_topic-981ee2d824e468272ea1721468daeca3.png";